const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/messages/' +
    path +
    (subPath ? `/${subPath}` : '/index'));

const routes = {
  path: '/messages',
  component: AppLayout,
  meta: {
    title: 'messages',
    hidden: true
  },
  redirect: 'list',
  children: [
    {
      path: 'list',
      name: 'messages-list',
      meta: {
        title: 'messages.list'
      },
      component: _import('list')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/messages.js